import React, { useState, useMemo } from 'react';
import { Box } from '@mui/joy';
import { KPI, Scorecard } from 'src/mtska-frontend-app-component';
import List from './List';
import LeadsDashboard from '../../Dashboard/views/LeadsDashboard';
import { useDataProvider } from 'src/mtska-frontend-data-provider';

const Default = () => {
    const [filters, setFilters] = useState();
    const date = new Date();
    const formattedDateToday = date.toISOString().split('T')[0];
    const startOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    const formattedDateStartOfMonth = `${startOfMonth.getFullYear()}/${String(startOfMonth.getMonth() + 1).padStart(2, '0')}/${String(startOfMonth.getDate()).padStart(2, '0')}`;

    const { item: user } = useDataProvider('auth/token');

    return (
        <>
            {!user?.data?.roles?.includes('Superadmin') &&
                <Box className="mtska-chart-wrapper">
                    <KPI
                        title="Leads"
                        icon="faPeople"
                        dataProviderName={'statistics/item/count/opportunities/lead'}
                    />
                    <KPI
                        title={"Leads current month (" + formattedDateStartOfMonth + ")"}
                        icon="faCalendar"
                        dataProviderName={'statistics/currentmonth/count/opportunities/lead'}
                        filters={{
                            'items': [{
                                'field': 'registered_at',
                                'operator': 'afterOrEqual',
                                'value': formattedDateStartOfMonth
                            }]
                        }}
                    />
                    <KPI
                        title={"Leads today"}
                        icon="faCalendarStar"
                        dataProviderName={'statistics/currentday/count/opportunities/lead'}
                        filters={{
                            'items': [{
                                'field': 'registered_at',
                                'operator': 'afterOrEqual',
                                'value': formattedDateToday
                            }]
                        }}
                    />
                </Box>
            }
            {user?.data?.roles?.includes('Superadmin') &&
                <LeadsDashboard setFilters={setFilters}/>
            }
            <List filters={filters}/>
        </>
    )

}

export default Default;


